import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

const SURVEY_URL = "https://forms.gle/e7eNRS7nwCULZoSk9";

interface DeleteAccountSurveyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const DeleteAccountSurveyModal = ({
  open,
  onOpenChange,
}: DeleteAccountSurveyModalProps) => {
  const handleTakeSurvey = () => {
    window.open(SURVEY_URL, "_blank", "noopener,noreferrer");
    onOpenChange(false);
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="px-4 pb-8">
        <DrawerHeader className="text-center pt-6">
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
              <Trash2 className="w-7 h-7 text-destructive" />
            </div>
          </div>
          <DrawerTitle className="text-xl">
            We're sorry to see you go
          </DrawerTitle>
          <DrawerDescription className="text-base">
            Before you leave, would you share what we could improve?
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter className="flex flex-col gap-2 pt-4">
          <Button onClick={handleTakeSurvey} variant="outline" className="w-full min-h-[44px]">
            Share feedback (optional)
          </Button>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className="w-full min-h-[44px] text-muted-foreground"
          >
            Close
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
